import lotesApi from "@/app/services/lotes";

export default {
  namespaced: true,
  state: {
    lote: {
      id: null,
      descricao: "",
    },
    lotes: [],
    pagination: {},
    total_de_registros: 1,
    search: "",
  },

  mutations: {
    listar(state, lotes) {
      state.lotes = lotes;
    },

    ABRIR(state, lote) {
      state.lote = lote;
    },

    ADICIONAR(state, lote) {
      state.lotes.unshift(lote);
    },

    ATUALIZAR(state, lote) {
      let index = state.lotes.findIndex((lote_) => lote_.id == lote.id);
      if (index > -1) {
        state.lotes.splice(index, 1, lote);
      }
    },

    EXCLUIR(state, id) {
      let index = state.lotes.findIndex((lote) => lote.id == id);
      if (index > -1) {
        state.lotes.splice(index, 1);
      }
    },

    UNSET_LOTE(state) {
      state.lote = null;
    },

    SET_TOTAL(state, total) {
      state.total_de_registros = total;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    SET_SEARCH(state, search) {
      state.search = search;
    },

    UPDATE_PAGINATION(state, options) {
      state.pagination = options;
    },

    ZERAR(state) {
      state.lote = {
        id: "",
        descricao: "",
      };
    },
  },

  actions: {
    async listar({ commit, state }) {
      commit("LOADING_ON", null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

      const parametros = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      if (state.search) {
        parametros.search = state.search;
        parametros.page = 1;
      }

      let response = await lotesApi.listar(parametros);
      commit("listar", response.data);
      commit("SET_TOTAL", response.total);
      commit("LOADING_OFF", null, { root: true });
    },

    async abrir({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let lote = await lotesApi.abrir(id);
      commit("ABRIR", lote);
      commit("LOADING_OFF", null, { root: true });
    },

    async salvar({ commit, dispatch }, lote) {
      let novo_lote = await lotesApi.salvar(lote);
      commit("ADICIONAR", novo_lote);
      dispatch("listar");
    },

    async atualizar({ commit }, lote) {
      await lotesApi.atualizar(lote);
      commit("ATUALIZAR", lote);
    },

    async excluir({ commit }, id) {
      await lotesApi.excluir(id);
      commit("EXCLUIR", id);
    },
  },
};
